<template>
  <aside class="menu-expanded">
    <el-menu
      :default-active="$route.path"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      unique-opened
      router
    >
      <template v-for="(item, index) in availableRoutes">
        <el-submenu
          class="separator"
          :index="index + ''"
          v-if="item.separator"
          :key="`${item.meta.label} ${index}`"
        >
          <!-- Menu Item Header -->
          <template slot="title">
            <span class="menu__item menu__item--separator">{{
              item.meta.label
            }}</span>
          </template>
        </el-submenu>
        <el-submenu
          :index="index + ''"
          v-else-if="showSubmenu(item)"
          :key="`${item.path} ${index}`"
        >
          <!-- Menu Item Header -->
          <template slot="title">
            <i :class="item.iconCls"></i>
            <span class="menu__item">{{ getRouteName(item) }}</span>
          </template>
          <!-- Menu Item Children -->
          <el-menu-item
            v-for="child in visibleChildren(item)"
            :index="getChildPath(item.path, child.path)"
            :key="getChildPath(item.path, child.path)"
            class="menu__item"
          >
            {{ getRouteName(child) }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-if="item.leaf && item.children.length > 0"
          :key="item.children[0].path"
          :index="item.children[0].path"
        >
          <i :class="item.iconCls"></i>{{ item.children[0].name }}
        </el-menu-item>
      </template>
      <el-menu-item index="" @click="logout">
        <i class="fa fa-unlock"></i> Wyloguj
      </el-menu-item>
    </el-menu>
  </aside>
</template>
<script>
import { SiteSettings } from '@/api'

export default {
  methods: {
    getChildPath(parentPath, childPath) {
      if (parentPath === undefined) {
        return childPath
      }
      if (parentPath.endsWith('/')) {
        return `${parentPath}${childPath}`
      }
      return `${parentPath}/${childPath}`
    },
    handleOpen() {},
    handleClose() {},
    handleSelect: function(a, b) {},
    logout: function() {
      this.$confirm(this.$i18n.t('areYouSure'), this.$i18n.t('logout'), {
        //type: 'warning'
      })
        .then(() => {
          window.localStorage.removeItem('token')
          this.$router.push('/login')
        })
        .catch(() => {})
    },
    showSubmenu(item) {
      return !item.leaf && this.visibleChildren(item).length
    },
    visibleChildren(item) {
      const removeHidden = child => !child.hidden
      return item.children.filter(removeHidden)
    }
  },
  computed: {
    availableRoutes() {
      return this.$router.options.routes.filter(route => !route.hidden)
    }
  }
}
</script>
<style scoped lang="scss">
.container {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;

  .main {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;

    aside {
      position: fixed;
      width: 220px;
      left: 0;
      top: 0;
      flex: 0 0 220px;
      height: 100vh;
      overflow: hidden;

      .el-menu {
        position: absolute;
        top: 0;
        bottom: -15px;
        left: 0;
        right: -15px;
        overflow: auto;
        background: #2f4050;
        font-size: 120px;
      }
    }

    .menu-expanded {
      flex: 0 0 220px;
      width: 220px;
    }
  }
}

.separator {
  pointer-events: none;
  background: #4b6075;
}

.menu__item {
  font-size: 13px;
  font-weight: 600;

  &--separator {
    font-size: 15px;
    font-weight: 400;
  }
}

.el-submenu {
  transition: all 0.3s;
}

.el-submenu.is-opened {
  background: #293846;
  border-left: 4px solid #66b1ff;
}

.el-menu-item,
.el-submenu .el-menu-item {
  background: #293846;
  color: #a7b1c2;
}

.el-menu-item.is-active {
  background: #66b1ff;
  color: #dceaff;
}

.white {
  color: #ffffff;
}

.sidebar {
  padding: 15px 0 0 0;
}

/deep/ .el-submenu {
  &__title {
    &:hover {
      background-color: #252f38 !important;
    }
  }
}

/deep/ .menu {
  &__item {
    color: #f3f3f3;
  }
}
</style>
